export const MAIN_ROUTES = {
    login: '/',
    private_login: '/login-privado',
    app_modules: '/app'
}

export const APP_ROUTES = {
    /** Orders */
    create_order: '/create-order',
    orders_box: '/orders-box',
    orders_box_inm:'/orders-box-inm',
    orders_history: '/orders-history',
    orders_history_group_date: '/orders-history-group-date',
    orders_history_group_client: '/orders-history-group-client',
    orders: '/orders',
    seller_client_orders: "/seller-client-orders",
    seller_orders: '/seller-orders',
    
    client_orders: '/client-orders',
    client_prices:'/client-prices',
    general_client_info_group: '/general-client-info-group',
    general_client_info: '/general-client-info',
    general_client_info_live: '/general-client-info-live',
    general_client_info_departures: '/general-client-info-departures',
    departures_history: '/departures-history',
    general_client_info_all: '/general-client-info-all',
    general_client_orders: '/general-client-orders',
    remission_list: '/remission-list',
    /** Departures */
    departures: '/departures',
    seller_departures: "/seller-departures",
    despatch_client_date: '/despatch-client-date',

    /** Payments */
    payments: '/payments',
    seller_payments: "/seller-payments",

    /** Poket Balance */
    pocket_balance: '/pocket-balance',
    seller_pocket_balance: "/seller-pocket-balance",

    /** Config */
    products: '/products',
    colors: '/colors',
    clients: '/clients',
    sellers: '/sellers',
    prices: '/prices',
    ean: '/ean',

    /** Users */
    users: '/users',

    /** Profile */
    profile: '/profile',

    /** Viewes */
    prices_view: '/prices-view',
    general_history : '/general-history',
    general_view: '/general-view',
    
    
    /** Process_viewes */
    crude:'/crude',
    dry_cleaner:'/dry_cleaner',
    validation:'/validation'   ,
    rolled_up:'/rolled_up',
    despatch:'/despatch',
    marked:'/marked',
    remission:'/remission',
    history:"/history",
    review:"/review",
    invoice:"/invoice",
    remission_fact: "/remission-fact",
    weaving: '/weaving',
}